const Journal = () => import(/* webpackChunkName: "manager" */ './Index');

export default {
  routes: [
    {
      path: '/papr/journal',
      name: 'papr_journal',
      component: Journal
    }
  ]
}
